import { Box, Button, Stack, Typography } from "@mui/material"
import { OpenDetailIcon } from 'shared/icons'

import { useTrialPreview } from "../container"
import { TrialResult } from "interface/trial"

type TrialPreviewFooterProps = {
	trial: TrialResult
	container: ReturnType<typeof useTrialPreview>
}
export const TrialPreviewFooter = ({
	trial
}: TrialPreviewFooterProps) => {
	return (
		<Stack direction="row" padding={1} spacing={1} alignItems='center' flexWrap='wrap' useFlexGap>
			<Button
				variant="contained"
				startIcon={<OpenDetailIcon />}
				disabled={trial.url ? false : true}
				onClick={(event) => {
					event.preventDefault()
					if (trial.url) {
						window.open(trial.url, '_blank')
					}
				}}
				color="success"
			>
				詳細を開く
			</Button>
			<Typography variant='body2' component='div'>{trial.siteKey}</Typography>
			<Box sx={{ flexGrow: 1 }} />
		</Stack>
	)
}